import React from "react";
import { useLanguage } from "../LanguageContext";
import { Button } from "./button";

type Props = {
  page: number;
  totalPages: number;
  pageSize: number;
  pageSizeOptions?: number[];
  onPrev: () => void;
  onNext: () => void;
  onPageSizeChange: (size: number) => void;
  hidePageSizeSelector?: boolean;
};

export function TablePagination({
  page,
  totalPages,
  pageSize,
  pageSizeOptions = [10, 20, 50, 100],
  onPrev,
  onNext,
  onPageSizeChange,
  hidePageSizeSelector = false,
}: Props) {
  const { t } = useLanguage();
  return (
    <div className="flex items-center justify-between py-3 px-4">
      {!hidePageSizeSelector && (
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <span>{t("fees.pageSize.label")}:</span>
          <select
            className="h-8 border rounded px-2 bg-white"
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
          >
            {pageSizeOptions.map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>
        </div>
      )}
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onPrev}
          disabled={page <= 1}
        >
          {t("pagination.prev")}
        </Button>
        <span className="text-sm text-gray-700">
          {t("pagination.page")} {page} {t("pagination.of")} {Math.max(1, totalPages)}
        </span>
        <Button
          variant="outline"
          size="sm"
          onClick={onNext}
          disabled={page >= totalPages}
        >
          {t("pagination.next")}
        </Button>
      </div>
    </div>
  );
}
